// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealsItem_meal__KfvFp","description":"MealsItem_description__n4jl2","price":"MealsItem_price__3hCEl"};